import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import API_BASE from './config';
import genzLogo from './assets/genz-logo.png';
import './SignIn.css';

const SignIn = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setError('');
    if (!username || !password) { setError('Please enter username and password.'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API_BASE}/api/v1/login`, { username, password });
      if (res.data.status === 'success') {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('username', username);
        localStorage.setItem('is_admin', res.data.is_admin);
        localStorage.setItem('is_super_admin', !!res.data.is_super_admin);
        localStorage.setItem('org_code', res.data.org_code || '');
        localStorage.setItem('role', res.data.role || (res.data.is_admin ? 'manager' : 'radiologist'));
        localStorage.setItem('full_name', res.data.full_name || '');
        localStorage.setItem('license', JSON.stringify(res.data.license || {}));
        navigate('/dashboard');
      } else {
        setError(res.data.message || 'Login failed.');
      }
    } catch (e) {
      setError('Server error. Please try again.');
    }
    setLoading(false);
  };

  return (
    <div className="login-root">
      <div className="login-cover">
        <img src={genzLogo} alt="Genz AI Labs" className="stroke-logo" />
      </div>
      <div className="login-card" onKeyDown={(e) => e.key === 'Enter' && handleLogin(e)}>
        <img src={genzLogo} alt="Genz AI Labs" style={{ width: 'min(200px, 50vw)', height: 'auto', marginBottom: '10px' }} />

        <h2 className="login-title">Quick Rad AI Login</h2>

        <p className="welcome-title">Welcome, enter your credentials below</p>

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="login-input"
        />
        <div className="password-input-container">
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="login-input"
          />
          {showPassword ? (
            <VisibilityOff
              className="password-toggle-icon"
              onClick={() => setShowPassword(false)}
            />
          ) : (
            <Visibility
              className="password-toggle-icon"
              onClick={() => setShowPassword(true)}
            />
          )}
        </div>

        <div className="remember-me-container">
          <input
            type="checkbox"
            id="rememberMe"
            className="remember-me-checkbox"
          />
          <label htmlFor="rememberMe" className="remember-me-label">
            Remember me
          </label>
        </div>

        <br />
        <button
          onClick={handleLogin}
          disabled={loading}
          className="login-button"
        >{loading ? 'Signing in...' : 'LOGIN'}</button>

        <div className="forgot-password-container">
          <p className="forgot-password">Forgot Password?</p>
          <p className="terms-text">
            By clicking on login, you agree to our <span className="terms-link">terms and conditions</span>.
          </p>
        </div>
        <p className="error-text">{error}</p>
      </div>
    </div>
  );
};

export default SignIn;
